import {AxiosServer, AxiosEsb,ArrRemoveSubItem} from '../../utils';
import {message} from 'antd';

let namespace = 'orderpending_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const orderPendingAc = {
	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},		

	GET:(value)=>(dispatch,getState)=>{
		
		let store =getState().orderPendingRd;
		let {dataFetchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...value,currentPage,pageSize}
		
		let Axios = AxiosServer();
		return Axios.post('/order/findAll',dataFetchProps).then((res)=>{	
							
			if (res.data.status == true){				
				pagination ={...pagination,total:res.data.count}
				dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, pagination:pagination,dataLoading: false}}); // 翻页的时候，先更新 dataLoading: true
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '刷新失败'
			}
			
		}).catch((err)=>{
			message.error('orderList ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '错误'
	})
	},	
	
	PUSH:(value)=>(dispatch,getState)=>{		
		
		let Axios = AxiosEsb();
		return Axios.post('/api/towxsbank/submitOrderAndContract',value).then((res)=>{	
			
						
			if (res.data.status == true){
				
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}});  // 翻页的时候，先更新 dataLoading: true
				
				return '推送到银行成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '推送失败:' + res.data.msg 
			}
			
		}).catch((err)=>{
			message.error('orderList ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '错误'
	})
	},	
	
	PUSHSUB:(value)=>(dispatch,getState)=>{
		
		//推送补充订单到银行
		let Axios = AxiosEsb();
		return Axios.post('/api/towxsbank/submitSubsidiesOrder',value).then((res)=>{	
							
			if (res.data.status == true){
				
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}});  // 翻页的时候，先更新 dataLoading: true
				return '推送到银行成功,银行返回消息:' + res.data.msg;
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '推送到银行失败'
			}
			
		}).catch((err)=>{
			message.error('orderList ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '错误'
	})
	},	
	
	
	UPDATE:(value, selectedRowIndex = null)=>(dispatch,getState)=>{
		//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态	
		//dispatch({type:'login/set',payload:{loading:true}});
		//value 是传过来的参数
		//getState 可获取当前store的状态
		//强转id为数字，规免出错
		let id = parseInt(value.id);	
		let store = getState();
		let currentStore =store.orderPendingRd	
		let dataFetchProps =currentStore.dataFetchProps		
		let {include} =dataFetchProps		
		
		let Axios = AxiosServer();
		return  Axios.post('/order/updateWithInclude',{id,value,include}).then((res)=>{		
		   
			dispatch({type:namespace+'updateDataById', payload: {id: value.id, data: res.data.data, selectedRowIndex}});		
		//   dispatch(userlist_GET({order:[['id']]}));
		   return '更新成功'
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},	
	UPDATEREMOVE:(value,selectedRowIndex)=> (dispatch,getState)=>{	
		
		let id = parseInt(value.id);	
		
		let store = getState();
		let currentStore =store.orderPendingRd	
		let dataFetchProps =currentStore.dataFetchProps		
		let {include} =dataFetchProps		
		let Axios = AxiosServer();			
		return  Axios.post('/order/updateWithInclude2',{id,value,include}).then((res)=>{
			if (res.data.status === true){
				dispatch({type:namespace+'updateDataById', payload: {id: value.id, data: res.data.data, selectedRowIndex}});
				dispatch({type:namespace+'RemoveDataByIndex', payload: {selectedRowIndex}});

				return '更新成功'
			}else {
				return '这笔不能拒绝'
			}

		}).catch((err)=>{
			dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
		
	
	}
	

}


export {orderPendingAc};